<div id="bilderKarussell">
  <div id="bilderkarusellGrp">
    <app-pwa-install></app-pwa-install>
  </div>
</div>
